import {useState, useEffect, useRef} from 'react'
import Axios from 'axios'
import { useTranslation } from "react-i18next"
import Swal from 'sweetalert2'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'

/**
 * 
 * @returns 
 */
export const Forgot = () => {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState('');
    const recaptchaRef = useRef(null);
    const widgetIdRef = useRef(null);
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

    // Carga el widget de Google reCAPTCHA v2 (checkbox "No soy un robot")
    useEffect(() => {
        if (!siteKey) return;

        window.onRecaptchaLoad = () => {
            if (window.grecaptcha && recaptchaRef.current && widgetIdRef.current === null) {
                try {
                    widgetIdRef.current = window.grecaptcha.render(recaptchaRef.current, {
                        sitekey: siteKey,
                        callback: (token) => setRecaptchaToken(token),
                        'expired-callback': () => setRecaptchaToken(''),
                        'error-callback': () => setRecaptchaToken(''),
                    });
                } catch (e) {
                    console.error('Error renderizando reCAPTCHA:', e);
                }
            }
        };

        if (window.grecaptcha && window.grecaptcha.render) {
            window.onRecaptchaLoad();
            return;
        }

        let script = document.querySelector('script[data-recaptcha="true"]');
        if (!script) {
            script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit';
            script.async = true;
            script.defer = true;
            script.setAttribute('data-recaptcha', 'true');
            document.body.appendChild(script);
        }
    }, [siteKey]);

    const resetRecaptcha = () => {
        setRecaptchaToken('');
        try {
            if (window.grecaptcha && widgetIdRef.current !== null) {
                window.grecaptcha.reset(widgetIdRef.current);
            }
        } catch (e) {
            // Silencioso: si falla el reset no bloqueamos al usuario
        }
    };
    
    /**
     * Comprueba los datos del formulario
     * @param {*} e evento
     */
    const handleSubmit = async (e) => {
        e.preventDefault();      

        if (!recaptchaToken) {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: 'Por favor, marca la casilla "No soy un robot" antes de continuar',
                target: document.getElementById('root')
            })
            return;
        }

        // Obtenemos el mail del usuario
        const clientEmail =  {
            email: e.target.email.value.trim(),
            recaptchaToken: recaptchaToken
        };

        setIsLoading(true);
        
        // Enviamos la petición al /forgotpassword con el email
        await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/forgot/sendmail', clientEmail)
            .then((res) => {
                setIsLoading(false);
                resetRecaptcha();
                // Mostramos el popup informativo (mensaje genérico a propósito:
                // no revela si el correo existe para evitar enumeración por bots)
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'success',
                    text: res?.data?.message || 'Si el correo existe, recibirás un enlace para restablecer tu contraseña',
                    target: document.getElementById('root')
                })
                
            }).catch((err) => {
                setIsLoading(false);
                resetRecaptcha();
                const status = err?.response?.status;
                // Mensajes claros según el motivo (rate-limit, captcha, error)
                let msg = 'Ha habido un error al intentar enviar los datos, comprueba el correo introducido o vuelva a intentarlo más tarde';
                if (status === 429) msg = 'Has hecho demasiados intentos, espera unos minutos antes de volver a probar';
                else if (status === 400 || status === 403) msg = err?.response?.data?.message || 'Verificación anti-bots fallida, recarga e inténtalo de nuevo';
                // Mostramos el popup informativo
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'error',
                    text: msg
                })
            });
    } 
    return (
        <Container fluid>
            <Row>
                <Col xs={12} className='py-4'>
                    <div id="logotipo-auth" className='text-center text-md-start px-3 pb-5'><Link to="/login"><img src="/images/logotipo-skill.svg" alt="Logotipo skillconnectED" /></Link></div>
                    <Container className='p-0 py-5 p-md-5'>
                        <Row>
                            <Col className='px-5 text-center mb-4'>
                                <h1>{t('forgot.question')}</h1>
                                {t('forgot.help')}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={10} md={8} lg={5} className='mx-auto my-3'>
                                <Form className="formulario" onSubmit={handleSubmit}>
                                    <Row className="my-3">
                                        <Col>
                                            <Form.Label htmlFor='email'>{t('forgot.email')}</Form.Label>
                                            <Form.Control name="email" type="email" autoComplete="off" required />
                                        </Col>
                                    </Row>
                                    <Row className="my-3">
                                        <Col className="d-flex justify-content-center">
                                            {siteKey ? (
                                                <div ref={recaptchaRef} />
                                            ) : (
                                                <div className="text-danger small">Falta configurar REACT_APP_RECAPTCHA_SITE_KEY</div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="text-center my-3">
                                        <Col>
                                            <Button variant='primary' type="submit" className="w-100" disabled={isLoading || !recaptchaToken}>
                                                {isLoading
                                                    ?
                                                    <>
                                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                    </>
                                                    :
                                                    <>{t('forgot.submit')}</>
                                                }
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row className="text-center my-3">
                                        <Col>
                                            <Link to="/login" className='link'>{t('forgot.cancel')}</Link>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </Container>
    )    
}
